import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Botao } from '../../../web/src/componentes/base';
import { Carregando } from '../../../web/src/componentes/estados';
import { mensagemDeErro } from '../../../web/src/nucleo/api';
import { pget, ppost } from '../api';
import { CHAVE_SESSAO } from '../sessao';
import { Aviso, Moldura } from './publicas';

/** Termo novo publicado pela Malgo: o cliente lê e aceita antes de qualquer dado (o aceite fica registrado, com IP e aparelho). */
export function TermoPendente({ aoSair }: { aoSair: () => void }) {
  const { t } = useTranslation('portal');
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ['portal', 'termo'], queryFn: () => pget<{ termo: { id: string; versao: string; titulo: string; texto: string } | null }>('/termo') });
  const [aceito, setAceito] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  if (q.isPending) return <Carregando />;
  const termo = q.data?.termo;
  return (
    <Moldura titulo={t('termo.titulo')}>
      <div className="flex flex-col gap-4">
        <p className="text-sm text-tinta-2">{t('termo.texto')}</p>
        {erro && <Aviso tipo="erro">{erro}</Aviso>}
        {termo && (
          <>
            <p className="kicker">
              {termo.titulo} · {t('termo.versao', { versao: termo.versao })}
            </p>
            <div className="max-h-72 overflow-y-auto rounded-lg border border-borda bg-sup-2 p-3 text-sm whitespace-pre-wrap text-tinta-2" tabIndex={0} aria-label={termo.titulo}>
              {termo.texto}
            </div>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" className="size-4" checked={aceito} onChange={(e) => setAceito(e.target.checked)} />
              {t('convite.aceito')}
            </label>
            <Botao
              variante="primario"
              disabled={!aceito}
              onClick={async () => {
                try {
                  await ppost('/termo/aceitar', { termo_id: termo.id });
                  await qc.invalidateQueries({ queryKey: CHAVE_SESSAO });
                } catch (e) {
                  setErro(mensagemDeErro(e));
                  await q.refetch();
                }
              }}
            >
              {t('termo.aceitar')}
            </Botao>
          </>
        )}
        <button type="button" className="text-center text-sm text-tinta-2 hover:text-acento-forte" onClick={aoSair}>
          {t('menu.sair')}
        </button>
      </div>
    </Moldura>
  );
}
